/* Full-page search only. Predictive requests keep the customer's broad query. */
(() => {
  const originalKey = 'wp_q';
  const broadKey = 'wp_broad';
  const searchPage = document.body.classList.contains('template-search');

  const isSearchPath = (pathname) => /\/search\/?$/.test(pathname);
  const hasFieldSyntax = (query) => /(^|\s)(?:title|body|product_type|tag|vendor|variants\.(?:title|sku|barcode)):/i.test(query);
  const hasTitleSyntax = (query) => /(^|\s)title:/i.test(query);

  const tokenize = (query) => {
    const tokens = [];
    let index = 0;

    while (index < query.length) {
      while (/\s/.test(query[index] || '') && index < query.length) index += 1;
      if (index >= query.length) break;

      const quote = query[index];
      if (quote === '"' || quote === "'") {
        let end = index + 1;
        while (end < query.length) {
          if (query[end] === '\\') {
            end += 2;
            continue;
          }
          if (query[end] === quote) break;
          end += 1;
        }
        if (end < query.length && (end + 1 === query.length || /\s/.test(query[end + 1]))) {
          tokens.push({ value: query.slice(index + 1, end), quoted: true });
          index = end + 1;
          continue;
        }
      }

      let end = index;
      while (end < query.length && !/\s/.test(query[end])) end += 1;
      tokens.push({ value: query.slice(index, end), quoted: false });
      index = end;
    }

    return tokens.filter((token) => token.value.trim());
  };

  const titleQuery = (original) => {
    if (!original || hasFieldSyntax(original)) return null;
  const phrase = original.trim().replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  return `title:"${phrase}"`;
    if (!original || hasFieldSyntax(original)) return null;
    const tokens = tokenize(original);
    if (tokens.length < 2 && !tokens.some((token) => token.quoted && /\s/.test(token.value))) return null;

    return tokens.map((token) => {
      const escaped = token.value
        .replace(/\\/g, '\\\\')
        .replace(/"/g, '\\"')
        .replace(/([:()])/g, '\\$1')
        .replace(/\*/g, '\\*');
      const needsQuotes = token.quoted || /^[-']/.test(token.value) || /["*]/.test(token.value);
      return `title:${needsQuotes ? `"${escaped}"` : escaped}`;
    }).join(' ');
  };

  const customerQuery = (url) => {
    const original = url.searchParams.get(originalKey);
    if (original !== null) return original;
    const query = url.searchParams.get('q') || '';
    if (!hasTitleSyntax(query)) return query;
    return query.replace(/(^|\s)title:/gi, '$1').replace(/\\([:\\()"*])/g, '$1');
  };

  const makeHidden = (form, name, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !isSearchPath(new URL(form.action).pathname)) return;
    if (form.querySelector('[aria-selected="true"] a')) return;

    const visibleInput = form.querySelector('input[type="search"][name="q"]');
    if (!visibleInput) return;
    const original = visibleInput.value.trim();
    const strict = titleQuery(original);
    if (!strict) return;

    visibleInput.removeAttribute('name');
    makeHidden(form, 'q', strict);
    makeHidden(form, originalKey, original);
    const prefix = form.querySelector('input[name="options[prefix]"]');
    if (prefix) prefix.value = 'none';
    else makeHidden(form, 'options[prefix]', 'none');
  }, true);

  if (!searchPage) return;

  const url = new URL(window.location.href);
  const query = url.searchParams.get('q') || '';
  const strict = url.searchParams.get(broadKey) === '1' ? null : titleQuery(query.trim());

  /* Covers links into /search, including predictive query suggestions. */
  if (strict) {
    url.searchParams.set('q', strict);
    url.searchParams.set(originalKey, query.trim());
    url.searchParams.set('options[prefix]', 'none');
    window.location.replace(url.toString());
    return;
  }

  if (url.searchParams.get(broadKey) === '1') {
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('#ProductGridContainer a[href]');
      if (!link) return;
      const target = new URL(link.href);
      if (target.origin !== window.location.origin || !isSearchPath(target.pathname)) return;
      if (target.searchParams.get('q') !== query) return;
      target.searchParams.set(broadKey, '1');
      link.href = target.toString();
    }, true);
    return;
  }

  if (!hasTitleSyntax(query)) return;
  const original = customerQuery(url);

  const refreshDisplay = () => {
    document.querySelectorAll('input[type="search"]').forEach((input) => {
      if (input.form && isSearchPath(new URL(input.form.action).pathname)) input.value = original;
    });
    document.querySelectorAll('[data-strict-search-customer-query]').forEach((element) => {
      element.textContent = original;
    });

    const fallback = document.querySelector('[data-strict-search-fallback]');
    if (fallback) {
      const fallbackUrl = new URL(fallback.href);
      fallbackUrl.searchParams.set('q', original);
      fallbackUrl.searchParams.set('options[prefix]', 'last');
      fallbackUrl.searchParams.set(broadKey, '1');
      fallbackUrl.searchParams.delete(originalKey);
      fallback.href = fallbackUrl.toString();
    }
  };
  window.wpStrictSearchRefresh = refreshDisplay;
  refreshDisplay();

  /* Shopify filter and pagination links may omit custom parameters. */
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    const target = new URL(link.href);
    if (target.origin !== window.location.origin || !isSearchPath(target.pathname)) return;
    if (!hasTitleSyntax(target.searchParams.get('q') || '')) return;
    target.searchParams.set(originalKey, original);
    target.searchParams.set('options[prefix]', 'none');
    link.href = target.toString();
  }, true);
})();
